import { Skeleton } from '@chakra-ui/react';

interface LoadingCountProps {
  isLoading: boolean;
  value: number;
  minWidth?: string | number;
}

export function LoadingCount({
  isLoading,
  value,
  minWidth = '2ch',
}: LoadingCountProps) {
  return (
    <Skeleton
      as="span"
      aria-busy={isLoading}
      display="inline-block"
      isLoaded={!isLoading}
      minW={isLoading ? minWidth : undefined}
      whiteSpace="nowrap"
    >
      {value.toLocaleString()}
    </Skeleton>
  );
}
